import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"
import { useSelector } from "react-redux"

import { useTranslate } from "context/translateContext"

import Commissions from "./Commissions"

import gridStyles from "../../../components/Plans.module.css"

const cx = classNames.bind(gridStyles)

const bodyClass = cx("row", "planCell")

const CostPerTransaction = props => {
  const { plans } = props
  const { t: translate } = useTranslate()
  const lang = useSelector(state => state.i18nState.lang)

  return (
    <>
      <div className={cx(bodyClass, "mobileHeading", "featureDescriptionCell")}>
        <p className={gridStyles.sectionTitleDark}>
          {translate("Cost per transaction")}
        </p>
        <span className={gridStyles.sectionHelperText}>
          {translate("(over included sales)")}
        </span>
      </div>
      {plans.map(plan => (
        <div
          key={`COST_PER_TRANSACTION_${plan.name}`}
          className={cx(
            bodyClass,
            "flex-container",
            "f-j-center",
            "f-a-center"
          )}
        >
          <Commissions
            commissions={plan.commission}
            price={plan.price}
            lang={lang}
            showLabel={false}
          />
        </div>
      ))}
    </>
  )
}

CostPerTransaction.propTypes = { plans: PropTypes.array }
CostPerTransaction.defaultProps = { plans: [] }

export default CostPerTransaction
